// @flow
import React from 'react';
import { slice } from 'lodash';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SocialPicturesGrid } from 'Components/widgets/social-pictures-grid/SocialPicturesGrid';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

const MIN_PICTURES_TO_SHOW = 5;
const MAX_PICTURES_TO_SHOW = 9;

type Props = {
  socialPictures: Array<SocialPicture>,
  title?: string,
};

export const ProductInstagramLine = ({ socialPictures = [], title }: Props) => {
  if (socialPictures.length < MIN_PICTURES_TO_SHOW) {
    return null;
  }

  const pictures = slice(socialPictures, 0, MAX_PICTURES_TO_SHOW).map(
    ({ imageLarge, imageSmall, userName, canonicalUrl }) => ({
      src: imageLarge,
      thumbnailSrc: imageSmall,
      canonicalUrl,
      userName,
    }),
  );

  return (
    <SiteContainer className="Line" size="medium">
      <LineTitle>{title}</LineTitle>
      <SocialPicturesGrid pictures={pictures} />
    </SiteContainer>
  );
};
